import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

import ActionCognitivePrompt from './ActionCognitivePrompt';
import CockpitNavigation from './CockpitNavigation';
import {
  ID_ACTION_BRANCHE_DEPUIS_CONVERSATION,
  POIDS_PILOTAGE_DEFAUT,
  chargerGrapheCognitif,
  cheminBrancheVivante,
  construirePromptActionCognitive,
  domainesRecommandationPilotage,
  filtrerRecommandationsPilotage,
  libelleValeurCognitive,
  lireProjectionGrapheCognitifEnCache,
  optionsFiltresPilotage,
  recalculerRecommandationsPilotage,
  trouverActionCognitive,
} from './grapheCognitifService';

const useStyles = makeStyles((theme) => ({
  page: { paddingTop: theme.spacing(3), paddingBottom: theme.spacing(4), textAlign: 'left' },
  paper: { padding: theme.spacing(2), marginBottom: theme.spacing(2), boxShadow: 'none', border: '1px solid #e5e7eb' },
  header: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(2), flexWrap: 'wrap', alignItems: 'center' },
  muted: { color: '#6b7280', fontSize: 12 },
  resumeBar: { display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap', marginTop: theme.spacing(1.5) },
  chipBleu: { backgroundColor: '#eff6ff', color: '#1d4ed8', fontSize: 11 },
  chipGris: { backgroundColor: '#f3f4f6', color: '#374151', fontSize: 11 },
  chipLien: { backgroundColor: '#f5f3ff', color: '#5b21b6', fontSize: 11 },
  tag: { backgroundColor: '#f9fafb', color: '#4b5563', fontSize: 11, border: '1px solid #e5e7eb' },
  erreur: { borderLeft: '4px solid #f59e0b', padding: theme.spacing(1.5), backgroundColor: '#fff7ed', marginTop: theme.spacing(1.5) },
  carte: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: theme.spacing(1.5) },
  domaine: { border: '1px solid #e5e7eb', borderRadius: 6, padding: theme.spacing(1.25), backgroundColor: '#fff' },
  pilotageFort: { backgroundColor: '#f8fafc' },
  panneauPilotage: { border: '1px solid #e5e7eb', borderRadius: 6, padding: theme.spacing(1.25), marginTop: theme.spacing(1.5), backgroundColor: '#fafafa' },
  filtresPilotage: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: theme.spacing(1), marginTop: theme.spacing(1.25), alignItems: 'end' },
  controleFiltre: { display: 'grid', gap: 4 },
  selectFiltre: { width: '100%', border: '1px solid #d1d5db', borderRadius: 4, backgroundColor: '#fff', padding: '6px 8px', fontSize: 13, color: '#111827' },
  grillePoids: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: theme.spacing(1.25), marginTop: theme.spacing(1) },
  controlePoids: { minWidth: 0 },
  lignePoids: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1), alignItems: 'baseline' },
  curseurPoids: { width: '100%', marginTop: theme.spacing(0.5) },
  legendePilotage: { display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap', marginTop: theme.spacing(1.25), alignItems: 'center' },
  paginationPilotage: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1), flexWrap: 'wrap', marginTop: theme.spacing(1.5), alignItems: 'center' },
  controlesPagination: { display: 'flex', gap: theme.spacing(1), flexWrap: 'wrap', alignItems: 'center' },
  pastilleLegende: { display: 'inline-block', width: 10, height: 10, borderRadius: 2, marginRight: 4 },
  domaineVide: { border: '1px dashed #d1d5db', borderRadius: 6, padding: theme.spacing(1.25), backgroundColor: '#fafafa' },
  domaineTitre: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1), alignItems: 'baseline', marginBottom: theme.spacing(0.75) },
  domaineNom: { fontWeight: 600, color: '#374151', fontSize: 14 },
  branche: { borderLeft: '4px solid #111827', padding: theme.spacing(1.25), marginTop: theme.spacing(1), backgroundColor: '#f9fafb', borderRadius: 4 },
  brancheOuverte: { borderLeft: '4px solid #2563eb', padding: theme.spacing(1.25), marginTop: theme.spacing(1), backgroundColor: '#f8fafc', borderRadius: 4 },
  brancheTitre: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(1), alignItems: 'flex-start' },
  titreBranche: { textTransform: 'none', justifyContent: 'flex-start', textAlign: 'left', padding: 0, minWidth: 0, fontSize: 15, lineHeight: 1.3, color: '#111827' },
  actionBranche: { textTransform: 'none', minWidth: 0, padding: '2px 6px', fontSize: 11 },
  metaLigne: { display: 'flex', gap: theme.spacing(0.75), flexWrap: 'wrap', marginTop: theme.spacing(0.75) },
  details: { marginTop: theme.spacing(1.25), paddingTop: theme.spacing(1), borderTop: '1px solid #e5e7eb' },
  detailLigne: { display: 'grid', gridTemplateColumns: '120px 1fr', gap: theme.spacing(1), marginTop: theme.spacing(0.75), alignItems: 'baseline' },
  metriquesCompactes: { display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: theme.spacing(0.75), marginTop: theme.spacing(1.25) },
  metriqueCompacte: { minWidth: 0 },
  jaugeEntete: { display: 'flex', justifyContent: 'space-between', gap: theme.spacing(0.5), alignItems: 'baseline', marginBottom: 3 },
  jaugeLibelle: { color: '#4b5563', fontSize: 11, fontWeight: 600 },
  jaugeValeur: { color: '#111827', fontSize: 11, fontVariantNumeric: 'tabular-nums' },
  jaugePiste: { position: 'relative', height: 8, borderRadius: 4, overflow: 'hidden', backgroundColor: '#e5e7eb', border: '1px solid #d1d5db' },
  jaugeRemplissage: { position: 'absolute', top: 0, left: 0, bottom: 0 },
  jaugeInconnue: { backgroundImage: 'repeating-linear-gradient(45deg, #d1d5db 0, #d1d5db 3px, #f9fafb 3px, #f9fafb 6px)' },
  actionsCarte: { display: 'flex', gap: theme.spacing(1), alignItems: 'center', flexWrap: 'wrap', marginTop: theme.spacing(1.25) },
  label: { color: '#6b7280', fontSize: 12, fontWeight: 600 },
  valeur: { color: '#111827', fontSize: 13 },
  branchesLiees: { marginTop: theme.spacing(1), paddingTop: theme.spacing(1), borderTop: '1px dashed #d1d5db' },
  referenceBranche: { color: '#4b5563', fontSize: 12, lineHeight: 1.4, marginTop: theme.spacing(0.5) },
}));

const CockpitGrapheCognitif = () => {
  const classes = useStyles();
  const donneesInitiales = lireProjectionGrapheCognitifEnCache();
  const [donnees, setDonnees] = useState(donneesInitiales);
  const [chargement, setChargement] = useState(!donneesInitiales);
  const [erreur, setErreur] = useState('');
  const [brancheOuverte, setBrancheOuverte] = useState('');
  const [afficherDomainesVides, setAfficherDomainesVides] = useState(false);
  const [actionOuverte, setActionOuverte] = useState(false);
  const [vueGlobale, setVueGlobale] = useState('inventaire');

  const charger = (options = {}) => {
    const forcer = Boolean(options && options.forcer);
    const projectionEnCache = lireProjectionGrapheCognitifEnCache();
    if (!forcer && projectionEnCache) {
      setDonnees(projectionEnCache);
      setErreur('');
      setChargement(false);
      return;
    }
    setChargement(true);
    chargerGrapheCognitif(options)
      .then((payload) => {
        setDonnees(payload);
        setErreur('');
        setChargement(false);
      })
      .catch((err) => {
        setErreur(err.message);
        setChargement(false);
      });
  };

  useEffect(() => {
    charger();
  }, []);

  const actionBrancheDepuisConversation = trouverActionCognitive(donnees, ID_ACTION_BRANCHE_DEPUIS_CONVERSATION);
  const promptBrancheDepuisConversation = construirePromptActionCognitive(actionBrancheDepuisConversation);

  return (
    <Container maxWidth={false} className={classes.page}>
      <CockpitNavigation vueActive="graphe-cognitif" />
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <div>
            <Typography variant="h4">Graphe cognitif SyncStats</Typography>
            <Typography variant="body2" className={classes.muted}>
              Projection de lecture du graphe canonique: domaines, Branches vivantes, ancrages et liens transverses.
            </Typography>
          </div>
          <Button variant="outlined" size="small" onClick={() => charger({ forcer: true })} disabled={chargement}>
            {chargement ? 'Chargement...' : 'Actualiser'}
          </Button>
          <ActionCognitivePrompt
            prompt={promptBrancheDepuisConversation}
            ouvert={actionOuverte}
            setOuvert={setActionOuverte}
          />
        </div>
        {donnees && <ResumeGraphe donnees={donnees} classes={classes} />}
        {donnees && (
          <NavigationVuesGlobales
            classes={classes}
            vueGlobale={vueGlobale}
            setVueGlobale={setVueGlobale}
            nbRecommandations={donnees.pilotage.candidats.length}
          />
        )}
        {erreur && (
          <div className={classes.erreur}>
            <Typography variant="subtitle2">Projection indisponible</Typography>
            <Typography variant="body2">{erreur}</Typography>
          </div>
        )}
      </Paper>

      {donnees && (
        <ProjectionGrapheCognitif
          donnees={donnees}
          classes={classes}
          brancheOuverte={brancheOuverte}
          setBrancheOuverte={setBrancheOuverte}
          afficherDomainesVides={afficherDomainesVides}
          setAfficherDomainesVides={setAfficherDomainesVides}
          vueGlobale={vueGlobale}
        />
      )}
    </Container>
  );
};

export const ProjectionGrapheCognitif = ({
  donnees,
  classes,
  brancheOuverte,
  setBrancheOuverte,
  afficherDomainesVides,
  setAfficherDomainesVides,
  vueGlobale,
}) => {
  const domainesVisibles = donnees.domaines.filter((domaine) => domaine.visibleParDefaut);
  const domainesVides = donnees.domaines.filter((domaine) => !domaine.visibleParDefaut);
  const domaines = afficherDomainesVides ? donnees.domaines : domainesVisibles;

  if (vueGlobale === 'pilotage') {
    return <VuePilotage donnees={donnees} classes={classes} />;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {domainesVides.length > 0 && (
          <Button
            variant="text"
            size="small"
            onClick={() => setAfficherDomainesVides(!afficherDomainesVides)}
            style={{ marginBottom: 8, textTransform: 'none' }}
          >
            {afficherDomainesVides ? 'Masquer les domaines vides' : `Afficher les domaines vides (${domainesVides.length})`}
          </Button>
        )}
        <div className={classes.carte}>
          {domaines.map((domaine) => (
            <DomaineCard
              key={domaine.id}
              domaine={domaine}
              classes={classes}
              brancheOuverte={brancheOuverte}
              setBrancheOuverte={setBrancheOuverte}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};


const NavigationVuesGlobales = ({ classes, vueGlobale, setVueGlobale, nbRecommandations }) => (
  <div className={classes.resumeBar} style={{ marginTop: 16 }}>
    <Button
      variant={vueGlobale === 'inventaire' ? 'contained' : 'outlined'}
      color={vueGlobale === 'inventaire' ? 'primary' : 'default'}
      size="small"
      onClick={() => setVueGlobale('inventaire')}
      style={{ textTransform: 'none' }}
    >
      Inventaire
    </Button>
    <Button
      variant={vueGlobale === 'pilotage' ? 'contained' : 'outlined'}
      color={vueGlobale === 'pilotage' ? 'primary' : 'default'}
      size="small"
      onClick={() => setVueGlobale('pilotage')}
      style={{ textTransform: 'none' }}
    >
      Pilotage ({nbRecommandations})
    </Button>
  </div>
);

const NB_CARTES_PILOTAGE_PAR_PAGE = 12;

export const VuePilotage = ({ donnees, classes }) => {
  const [poids, setPoids] = useState(POIDS_PILOTAGE_DEFAUT);
  const [pageCourante, setPageCourante] = useState(1);
  const [filtres, setFiltres] = useState({ domaine: '', acteur: '', typeTravail: '' });
  const candidats = donnees.pilotage.candidats || donnees.pilotage.recommandations || [];
  const optionsFiltres = useMemo(
    () => optionsFiltresPilotage(candidats, donnees.domaines),
    [candidats, donnees.domaines]
  );
  const candidatsFiltres = useMemo(
    () => filtrerRecommandationsPilotage(candidats, filtres),
    [candidats, filtres]
  );
  const recommandationsClassees = useMemo(
    () => recalculerRecommandationsPilotage(candidatsFiltres, poids),
    [candidatsFiltres, poids]
  );
  const nbPages = Math.max(1, Math.ceil(recommandationsClassees.length / NB_CARTES_PILOTAGE_PAR_PAGE));
  const pageStable = Math.min(pageCourante, nbPages);
  const indexDebut = (pageStable - 1) * NB_CARTES_PILOTAGE_PAR_PAGE;
  const recommandations = recommandationsClassees.slice(indexDebut, indexDebut + NB_CARTES_PILOTAGE_PAR_PAGE);
  const debutAffichage = recommandationsClassees.length === 0 ? 0 : indexDebut + 1;
  const finAffichage = indexDebut + recommandations.length;

  useEffect(() => {
    if (pageCourante > nbPages) setPageCourante(nbPages);
  }, [pageCourante, nbPages]);

  useEffect(() => {
    setPageCourante(1);
  }, [candidats.length]);

  useEffect(() => {
    setPageCourante(1);
  }, [filtres]);

  const changerPoids = (critere, valeur) => {
    setPoids({
      ...poids,
      [critere]: Number(valeur),
    });
    setPageCourante(1);
  };
  const changerFiltre = (nom, valeur) => {
    setFiltres((courants) => ({
      ...courants,
      [nom]: valeur,
    }));
  };
  const reinitialiserFiltres = () => setFiltres({ domaine: '', acteur: '', typeTravail: '' });
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <div>
              <Typography variant="h5">Pilotage</Typography>
              <Typography variant="body2" className={classes.muted}>
                Chemins experimentaux derives des Frontieres du graphe. Les ponderations classent l'ensemble candidat avant l'affichage.
              </Typography>
            </div>
            <Chip size="small" label={`${recommandationsClassees.length} / ${candidats.length} mouvements`} className={classes.chipBleu} />
          </div>
          <FiltresPilotage
            classes={classes}
            filtres={filtres}
            options={optionsFiltres}
            changerFiltre={changerFiltre}
            reinitialiser={reinitialiserFiltres}
          />
          <PanneauPoidsPilotage
            classes={classes}
            poids={poids}
            changerPoids={changerPoids}
            reinitialiser={() => {
              setPoids(POIDS_PILOTAGE_DEFAUT);
              setPageCourante(1);
            }}
          />
          <PaginationPilotage
            classes={classes}
            debutAffichage={debutAffichage}
            finAffichage={finAffichage}
            total={recommandationsClassees.length}
            pageCourante={pageStable}
            nbPages={nbPages}
            allerPagePrecedente={() => setPageCourante(Math.max(1, pageStable - 1))}
            allerPageSuivante={() => setPageCourante(Math.min(nbPages, pageStable + 1))}
          />
        </Paper>
        {recommandations.length === 0 && (
          <Paper className={classes.paper}>
            <Typography variant="body2" className={classes.muted}>Aucun mouvement candidat ne correspond aux filtres actifs.</Typography>
          </Paper>
        )}
        <div className={classes.carte}>
          {recommandations.map((recommandation) => (
            <RecommandationPilotage
              key={`${recommandation.branche.id}-${recommandation.frontiereId}-${recommandation.categorie}`}
              recommandation={recommandation}
              classes={classes}
            />
          ))}
        </div>
      </Grid>
    </Grid>
  );
};

const FiltresPilotage = ({ classes, filtres, options, changerFiltre, reinitialiser }) => (
  <div className={classes.filtresPilotage}>
    <ControleFiltre
      classes={classes}
      id="domaine"
      label="Domaine"
      valeur={filtres.domaine}
      options={options.domaines}
      libelleTous="Tous les domaines"
      changerFiltre={changerFiltre}
    />
    <ControleFiltre
      classes={classes}
      id="acteur"
      label="Acteur"
      valeur={filtres.acteur}
      options={options.acteurs}
      libelleTous="Tous les acteurs"
      changerFiltre={changerFiltre}
    />
    <ControleFiltre
      classes={classes}
      id="typeTravail"
      label="Type de travail"
      valeur={filtres.typeTravail}
      options={options.typesTravail}
      libelleTous="Tous les travaux"
      changerFiltre={changerFiltre}
    />
    <Button variant="outlined" size="small" onClick={reinitialiser} style={{ textTransform: 'none' }}>
      Tous
    </Button>
  </div>
);

const ControleFiltre = ({ classes, id, label, valeur, options, libelleTous, changerFiltre }) => (
  <label className={classes.controleFiltre}>
    <span className={classes.label}>{label}</span>
    <select
      className={classes.selectFiltre}
      value={valeur}
      onChange={(event) => changerFiltre(id, event.target.value)}
      aria-label={`Filtre ${label}`}
    >
      <option value="">{libelleTous}</option>
      {options.map((option) => (
        <option key={option.id} value={option.id}>{option.titre}</option>
      ))}
    </select>
  </label>
);

const RecommandationPilotage = ({ recommandation, classes }) => {
  const [detailsOuverts, setDetailsOuverts] = useState(false);
  const lien = cheminBrancheVivante(recommandation.branche.id, { frontiereId: recommandation.frontiereId });
  const score = recommandation.scorePilotage || { scorePourcent: 0, contributions: [], inconnus: [] };
  const domaines = domainesRecommandationPilotage(recommandation);
  return (
    <Paper
      className={`${classes.domaine} ${score.scorePourcent >= 75 ? classes.pilotageFort : ''}`}
      style={{ borderLeft: `4px solid ${couleurFranchissabilite(recommandation.franchissabilite.niveau)}` }}
    >
      <div className={classes.domaineTitre}>
        <Typography variant="body2" className={classes.muted}>{libelleCategorie(recommandation.categorie)}</Typography>
        <Chip size="small" label={`Attractivite ${score.scorePourcent}%`} className={classes.chipBleu} />
      </div>
      <Typography variant="h6" style={{ fontSize: 16, lineHeight: 1.25 }}>{recommandation.branche.titre}</Typography>
      <Typography variant="body2" className={classes.valeur} style={{ marginTop: 8 }}>{recommandation.objectifFrontiere}</Typography>
      <div className={classes.metaLigne}>
        <Chip size="small" label={`Travail: ${libelleValeurCognitive(recommandation.typeTravail)}`} className={classes.chipBleu} />
        <Chip size="small" label={`Acteur: ${libelleValeurCognitive(recommandation.acteurPotentiel)}`} className={classes.chipLien} />
        <Chip size="small" label={`Franchissabilite: ${libelleValeurCognitive(recommandation.franchissabilite.niveau)}`} className={classes.chipGris} />
      </div>
      <JaugesPilotage recommandation={recommandation} score={score} classes={classes} />
      <div className={classes.actionsCarte}>
        <Button component={Link} to={lien} variant="contained" color="primary" size="small" style={{ textTransform: 'none' }}>
          Ouvrir la Branche
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={() => setDetailsOuverts(!detailsOuverts)}
          aria-expanded={detailsOuverts}
          style={{ textTransform: 'none' }}
        >
          {detailsOuverts ? 'Details ^' : 'Details v'}
        </Button>
      </div>
      {detailsOuverts && (
        <DetailsPilotage
          recommandation={recommandation}
          score={score}
          domaines={domaines}
          classes={classes}
        />
      )}
    </Paper>
  );
};

const JaugesPilotage = ({ recommandation, score, classes }) => {
  const contributions = (score.contributions || []).reduce((index, contribution) => ({
    ...index,
    [contribution.id]: contribution.scorePourcent,
  }), {});
  return (
    <div className={classes.metriquesCompactes}>
      <JaugeMetrique
        classes={classes}
        label="Valeur"
        valeur={valeurNumeriqueSignal(recommandation.valeur)}
        score={contributions.valeur}
        etat={recommandation.valeur && recommandation.valeur.niveau}
        couleur="#2563eb"
      />
      <JaugeMetrique
        classes={classes}
        label="Pression"
        valeur={valeurNumeriqueSignal(recommandation.pression)}
        score={contributions.pression}
        etat={recommandation.pression && recommandation.pression.niveau}
        couleur="#dc2626"
      />
      <JaugeMetrique
        classes={classes}
        label="Chaleur"
        valeur={valeurNumeriqueSignal(recommandation.chaleur)}
        score={contributions.chaleur}
        etat={recommandation.chaleur && recommandation.chaleur.niveau}
        couleur="#d97706"
      />
      <JaugeMetrique
        classes={classes}
        label="Energie"
        valeur={valeurNumeriqueSignal(recommandation.energie)}
        score={scoreEnergieVisuel(recommandation.energie)}
        etat={recommandation.energie && recommandation.energie.niveau}
        couleur="#4b5563"
        aide="Effort d'activation: plus rempli signifie plus couteux."
      />
    </div>
  );
};

const JaugeMetrique = ({ classes, label, valeur, score, etat, couleur, aide }) => {
  const disponible = score !== null && score !== undefined;
  const nonDisponible = etat === 'non_disponible' || etat === 'non_evaluee';
  const largeur = disponible ? Math.max(0, Math.min(100, Number(score))) : 100;
  const texteValeur = valeur !== null && valeur !== undefined
    ? `${Math.round(Number(valeur))}`
    : nonDisponible
    ? 'N/D'
    : 'Inconnu';
  return (
    <div className={classes.metriqueCompacte} title={aide || `${label}: ${texteValeur}`}>
      <div className={classes.jaugeEntete}>
        <span className={classes.jaugeLibelle}>{label}</span>
        <span className={classes.jaugeValeur}>{texteValeur}</span>
      </div>
      <div
        className={`${classes.jaugePiste} ${disponible ? '' : classes.jaugeInconnue}`}
        aria-label={`${label} ${texteValeur}`}
      >
        {disponible && (
          <span
            className={classes.jaugeRemplissage}
            style={{
              width: `${largeur}%`,
              backgroundColor: couleur,
              opacity: nonDisponible ? 0.35 : 0.85,
            }}
          />
        )}
      </div>
    </div>
  );
};

const DetailsPilotage = ({ recommandation, score, domaines, classes }) => (
  <div className={classes.details}>
    <LigneListe
      classes={classes}
      label="Domaines"
      items={domaines}
      itemLabel={(domaine) => domaine.titre}
      vide="Aucun domaine structurel"
      chipClassName={classes.chipLien}
    />
    <LigneDetail classes={classes} label="Preuve" valeur={recommandation.preuveAttendue || 'Inconnue'} />
    {recommandation.blocage && <LigneDetail classes={classes} label="Blocage" valeur={recommandation.blocage} />}
    <DetailsSignauxPilotage recommandation={recommandation} classes={classes} />
    {recommandation.pourquoiCeChemin && (
      <LigneDetail classes={classes} label="Pourquoi" valeur={recommandation.pourquoiCeChemin} />
    )}
    <LigneDetail classes={classes} label="Score ajuste" valeur={resumeScorePilotage(score)} />
  </div>
);

const PaginationPilotage = ({
  classes,
  debutAffichage,
  finAffichage,
  total,
  pageCourante,
  nbPages,
  allerPagePrecedente,
  allerPageSuivante,
}) => (
  <div className={classes.paginationPilotage}>
    <Typography variant="body2" className={classes.muted}>
      {debutAffichage}{'\u2013'}{finAffichage} sur {total} chemins
    </Typography>
    <div className={classes.controlesPagination}>
      <Button
        variant="outlined"
        size="small"
        onClick={allerPagePrecedente}
        disabled={pageCourante <= 1}
        style={{ textTransform: 'none' }}
      >
        {'Pr\u00e9c\u00e9dent'}
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={allerPageSuivante}
        disabled={pageCourante >= nbPages}
        style={{ textTransform: 'none' }}
      >
        Suivant
      </Button>
    </div>
  </div>
);

const PanneauPoidsPilotage = ({ classes, poids, changerPoids, reinitialiser }) => (
  <div className={classes.panneauPilotage}>
    <div className={classes.header}>
      <div>
        <Typography variant="subtitle2">Ponderation du moment</Typography>
        <Typography variant="body2" className={classes.muted}>
          L'energie favorise les chemins faciles a activer. Les valeurs inconnues sont ignorees dans le score.
        </Typography>
      </div>
      <Button variant="outlined" size="small" onClick={reinitialiser} style={{ textTransform: 'none' }}>
        Reinitialiser
      </Button>
    </div>
    <div className={classes.grillePoids}>
      <ControlePoids classes={classes} id="valeur" label="Valeur" valeur={poids.valeur} changerPoids={changerPoids} />
      <ControlePoids classes={classes} id="pression" label="Pression" valeur={poids.pression} changerPoids={changerPoids} />
      <ControlePoids classes={classes} id="energie" label="Faible energie" valeur={poids.energie} changerPoids={changerPoids} />
      <ControlePoids classes={classes} id="chaleur" label="Chaleur" valeur={poids.chaleur} changerPoids={changerPoids} />
    </div>
    <div className={classes.legendePilotage}>
      <Typography variant="body2" className={classes.muted}>Bordure = franchissabilite:</Typography>
      {['prete', 'praticable', 'clarification_necessaire', 'bloquee', 'inconnue'].map((niveau) => (
        <Typography key={niveau} variant="body2" className={classes.muted}>
          <span className={classes.pastilleLegende} style={{ backgroundColor: couleurFranchissabilite(niveau) }} />
          {libelleValeurCognitive(niveau)}
        </Typography>
      ))}
    </div>
  </div>
);

const ControlePoids = ({ classes, id, label, valeur, changerPoids }) => (
  <div className={classes.controlePoids}>
    <div className={classes.lignePoids}>
      <Typography variant="body2" className={classes.valeur}>{label}</Typography>
      <Typography variant="body2" className={classes.muted}>{valeur}</Typography>
    </div>
    <input
      className={classes.curseurPoids}
      type="range"
      min="0"
      max="5"
      step="1"
      value={valeur}
      onChange={(event) => changerPoids(id, event.target.value)}
      aria-label={`Poids ${label}`}
    />
  </div>
);

const ResumeGraphe = ({ donnees, classes }) => (
  <div className={classes.resumeBar}>
    <Chip size="small" label={`${donnees.resume.nbDomaines} domaines`} className={classes.chipBleu} />
    <Chip size="small" label={`${donnees.resume.nbBranches} Branches vivantes`} className={classes.chipBleu} />
    <Chip size="small" label={`${donnees.resume.nbBranchesTransverses} transverse(s)`} className={classes.chipLien} />
    <Chip size="small" label={`${donnees.resume.nbFrontieresActives} Frontiere(s)`} className={classes.chipGris} />
    <Chip size="small" label={`${donnees.resume.nbMouvementsCandidats} mouvement(s) candidat(s)`} className={classes.chipGris} />
    <Chip size="small" label={`${donnees.resume.nbBranchesChaudes} chaude(s)`} className={classes.chipGris} />
    <Chip size="small" label={`${donnees.resume.nbPreuvesConnues} prochaine(s) preuve(s) connue(s)`} className={classes.chipGris} />
  </div>
);

const DomaineCard = ({ domaine, classes, brancheOuverte, setBrancheOuverte }) => {
  const nbBranches = domaine.branchesAncrees.length;
  const nbLiens = domaine.branchesLiees.length;

  return (
    <Paper className={nbBranches === 0 && nbLiens === 0 ? classes.domaineVide : classes.domaine}>
      <div className={classes.domaineTitre}>
        <Typography variant="body1" className={classes.domaineNom}>{domaine.titre}</Typography>
        {(nbBranches > 0 || nbLiens > 0) && (
          <Typography variant="body2" className={classes.muted}>
            {nbBranches} vivante(s){nbLiens > 0 ? ` - ${nbLiens} touchee(s)` : ''}
          </Typography>
        )}
      </div>

      {domaine.branchesAncrees.map((branche) => (
        <BrancheCard
          key={branche.id}
          branche={branche}
          classes={classes}
          ouverte={brancheOuverte === branche.id}
          basculer={() => setBrancheOuverte(brancheOuverte === branche.id ? '' : branche.id)}
        />
      ))}

      {nbBranches === 0 && nbLiens === 0 && (
        <Typography variant="body2" className={classes.muted}>Vide pour cette projection.</Typography>
      )}

      {nbLiens > 0 && (
        <div className={classes.branchesLiees}>
          <Typography variant="body2" className={classes.muted}>
            Touche par une branche ancree ailleurs
          </Typography>
          {domaine.branchesLiees.map((branche) => (
            <div key={branche.id} className={classes.referenceBranche}>
              {branche.titre} <span className={classes.muted}>depuis {branche.ancrage.titre}</span>
            </div>
          ))}
        </div>
      )}
    </Paper>
  );
};

const BrancheCard = ({ branche, classes, ouverte, basculer }) => (
  <div className={ouverte ? classes.brancheOuverte : classes.branche}>
    <div className={classes.brancheTitre}>
      <Button className={classes.titreBranche} component={Link} to={cheminBrancheVivante(branche.id)}>
        <strong>{branche.titre}</strong>
      </Button>
      {branche.estTransverse && <Chip size="small" label="transverse" className={classes.chipLien} />}
    </div>
    <div className={classes.metaLigne}>
      <Button size="small" variant="text" className={classes.actionBranche} onClick={basculer}>
        {ouverte ? 'Masquer apercu' : 'Apercu rapide'}
      </Button>
      <Chip size="small" label={`Chaleur: ${libelleSignal(branche.chaleur_experimentale.niveau)}`} className={classes.chipGris} />
      <Chip size="small" label={`${branche.chemins_attention.nb_frontieres_actives} Frontiere(s)`} className={classes.chipBleu} />
      {branche.chemins_attention.nb_mouvements_candidats > 0 && (
        <Chip size="small" label={`${branche.chemins_attention.nb_mouvements_candidats} mouvement(s) clair(s)`} className={classes.chipLien} />
      )}
    </div>
    {branche.etat_general && branche.etat_general !== 'a_confirmer' && (
      <div className={classes.metaLigne}>
        <Chip size="small" label={libelleValeurCognitive(branche.etat_general)} className={classes.chipGris} />
      </div>
    )}
    {ouverte && <DetailsBranche branche={branche} classes={classes} />}
  </div>
);

const DetailsBranche = ({ branche, classes }) => (
  <div className={classes.details}>
    <LigneDetail
      classes={classes}
      label="Chaleur"
      valeur={resumeChaleurDetail(branche.chaleur_experimentale)}
    />
    <LigneDetail
      classes={classes}
      label="Recence"
      valeur={branche.recence_experimentale.derniere_activite_substantielle || 'Inconnue'}
    />
    <LigneDetail
      classes={classes}
      label="Frontieres"
      valeur={`${branche.chemins_attention.nb_frontieres_actives} ouverte(s), ${branche.chemins_attention.nb_mouvements_candidats} mouvement(s) candidat(s)`}
    />
    <LigneDetail classes={classes} label="Prochaine preuve" valeur={branche.prochaine_preuve || 'Inconnue'} />
    <LigneDetail classes={classes} label="Reprise" valeur={libelleValeurCognitive(branche.energie_activation)} />
    <LigneDetail classes={classes} label="Preuves" valeur={libelleValeurCognitive(branche.solidite_preuves)} />
    <LigneListe
      classes={classes}
      label="Touche"
      items={branche.domainesLiesObjets}
      itemLabel={(domaine) => domaine.titre}
      vide="Aucun autre domaine"
      chipClassName={classes.chipLien}
    />
    <LigneListe
      classes={classes}
      label="Tags"
      items={branche.tags}
      itemLabel={(tag) => tag}
      vide="Aucun tag"
      chipClassName={classes.tag}
    />
    <Typography variant="body2" className={classes.muted} style={{ marginTop: 8 }}>
      Reprise = cout cognitif pour retrouver le contexte; ce n'est pas une priorite, une urgence ou une criticite.
    </Typography>
  </div>
);

const DetailsSignauxPilotage = ({ recommandation, classes }) => (
  <div style={{ marginTop: 8 }}>
    <ValeurMachineDetail valeur={recommandation.valeur} classes={classes} />
    <EnergieActivationDetail energie={recommandation.energie} classes={classes} />
    {recommandation.pression.niveau !== 'non_disponible' && (
      <Typography variant="body2" className={classes.muted}>
        Pression: {resumePressionDetail(recommandation.pression)}
      </Typography>
    )}
    {recommandation.chaleur.niveau !== 'inconnu' && (
      <Typography variant="body2" className={classes.muted}>
        Chaleur: {resumeChaleurDetail(recommandation.chaleur)}
      </Typography>
    )}
  </div>
);

const ValeurMachineDetail = ({ valeur, classes }) => {
  const machine = valeur && valeur.valeur_machine_v0;
  if (!machine) return null;
  const axes = [
    ['Impact', machine.axes.impact],
    ['Portee', machine.axes.portee],
    ['Recurrence', machine.axes.recurrence],
    ['Durabilite', machine.axes.durabilite],
    ['Levier', machine.axes.levier],
  ];
  return (
    <div style={{ marginTop: 8 }}>
      <Typography variant="body2" className={classes.valeur}>
        Valeur machine: {machine.score !== null && machine.score !== undefined ? `${machine.score}/100` : 'Inconnue'}
      </Typography>
      <Typography variant="body2" className={classes.muted}>
        {axes.map(([label, axe]) => `${label} ${axe && axe.score !== null && axe.score !== undefined ? axe.score : '?'}`).join(' · ')}
      </Typography>
      <Typography variant="body2" className={classes.muted}>
        Direct {machine.valeur_directe !== null && machine.valeur_directe !== undefined ? machine.valeur_directe : '?'} · Levier {machine.valeur_levier !== null && machine.valeur_levier !== undefined ? machine.valeur_levier : '?'}
      </Typography>
    </div>
  );
};

const EnergieActivationDetail = ({ energie, classes }) => {
  const machine = energie && energie.energie_activation_machine_v0;
  if (!machine) return null;
  const axes = [
    ['Distance preuve', machine.axes.distance_preuve],
    ['Complexite execution', machine.axes.complexite_execution],
    ['Dependances acces', machine.axes.dependances_acces],
    ['Coordination decision', machine.axes.coordination_decision],
  ];
  const raisons = axes
    .flatMap(([, axe]) => (axe && axe.raisons ? axe.raisons : []))
    .slice(0, 4);
  return (
    <div style={{ marginTop: 8 }}>
      <Typography variant="body2" className={classes.valeur}>
        Energie: {machine.score !== null && machine.score !== undefined ? `${machine.score}/100` : 'Inconnue'}
        {machine.certitude !== null && machine.certitude !== undefined ? `, certitude ${Math.round(machine.certitude * 100)}%` : ''}
      </Typography>
      <Typography variant="body2" className={classes.muted}>
        {axes.map(([label, axe]) => `${label} ${axe && axe.score !== null && axe.score !== undefined ? axe.score : '?'}`).join(' · ')}
      </Typography>
      {raisons.length > 0 && (
        <Typography variant="body2" className={classes.muted}>
          {raisons.join(' · ')}
        </Typography>
      )}
      {machine.limites.length > 0 && (
        <Typography variant="body2" className={classes.muted}>
          Limites: {machine.limites.slice(0, 2).join(' · ')}
        </Typography>
      )}
    </div>
  );
};

const LigneDetail = ({ classes, label, valeur }) => (
  <div className={classes.detailLigne}>
    <div className={classes.label}>{label}</div>
    <div className={classes.valeur}>{valeur}</div>
  </div>
);

const LigneListe = ({ classes, label, items, itemLabel, vide, chipClassName }) => (
  <div className={classes.detailLigne}>
    <div className={classes.label}>{label}</div>
    <div className={classes.metaLigne} style={{ marginTop: 0 }}>
      {items.length > 0
        ? items.map((item) => (
          <Chip key={typeof item === 'string' ? item : item.id} size="small" label={itemLabel(item)} className={chipClassName} />
        ))
        : <span className={classes.muted}>{vide}</span>}
    </div>
  </div>
);

function libelleSignal(valeur) {
  const libelles = {
    tres_chaud: 'Tres chaud',
    chaud: 'Chaud',
    tiede: 'Tiede',
    froid: 'Froid',
    inconnu: 'Inconnu',
  };
  return libelles[valeur] || libelleValeurCognitive(valeur);
}


function libelleCategorie(valeur) {
  const libelles = {
    gain_rapide: 'Petit gain rapide',
    delegable_agent: 'Delegable agent',
    pression_operationnelle: 'Pression operationnelle',
    decision_humaine_utile: 'Decision humaine utile',
    meilleur_chemin_global: 'Chemin global',
    chemin_a_examiner: 'Chemin a examiner',
  };
  return libelles[valeur] || libelleValeurCognitive(valeur);
}

function resumeChaleurCourte(chaleur) {
  const libelle = libelleSignal(chaleur && chaleur.niveau);
  if (chaleur && chaleur.chaleur_continue !== null && chaleur.chaleur_continue !== undefined) {
    return `${libelle} ${chaleur.chaleur_continue}/100`;
  }
  return libelle;
}

function valeurNumeriqueSignal(signal) {
  if (!signal) return null;
  if (signal.valeur_machine_v0 && signal.valeur_machine_v0.score !== null && signal.valeur_machine_v0.score !== undefined) {
    return signal.valeur_machine_v0.score;
  }
  if (signal.valeur_continue !== null && signal.valeur_continue !== undefined) return signal.valeur_continue;
  if (signal.chaleur_continue !== null && signal.chaleur_continue !== undefined) return signal.chaleur_continue;
  if (signal.valeur !== null && signal.valeur !== undefined && signal.valeur !== '') return signal.valeur;
  return null;
}

function scoreEnergieVisuel(energie) {
  const valeur = valeurNumeriqueSignal(energie);
  if (valeur !== null && valeur !== undefined) return valeur;
  const niveaux = {
    faible: 25,
    moyenne: 55,
    forte: 85,
    elevee: 100,
  };
  return energie && Object.prototype.hasOwnProperty.call(niveaux, energie.niveau) ? niveaux[energie.niveau] : null;
}

function resumeChaleurDetail(chaleur) {
  if (!chaleur) return 'Inconnue';
  if (chaleur.explication) return chaleur.explication;
  const base = `${libelleSignal(chaleur.niveau)} (${chaleur.nb_commits_correspondants_30j} commit(s) correspondant(s) sur 30 jours)`;
  if (chaleur.chaleur_continue !== null && chaleur.chaleur_continue !== undefined) {
    return `${base}, ${chaleur.chaleur_continue}/100`;
  }
  return base;
}

function resumePressionCourte(pression) {
  if (!pression || pression.niveau === 'non_disponible') return 'Non disponible';
  const libelle = libelleValeurCognitive(pression.niveau);
  if (pression.valeur !== '') return `${libelle} ${pression.valeur}/100`;
  return libelle;
}

function resumeValeurCourte(valeur) {
  const machine = valeur && valeur.valeur_machine_v0;
  if (machine && machine.score !== null && machine.score !== undefined) {
    return `machine ${machine.score}/100`;
  }
  return libelleValeurCognitive(valeur && valeur.niveau);
}

function resumePressionDetail(pression) {
  const raisons = (pression.raisons || []).slice(0, 3).join(' + ');
  const source = pression.source || pression.provenance || 'Monitoring';
  const valeur = pression.valeur !== '' ? `${pression.valeur}/100` : libelleValeurCognitive(pression.niveau);
  return `${valeur} - ${raisons || 'signal observe'} (${source})`;
}

function resumeScorePilotage(score) {
  const contributions = (score.contributions || [])
    .map((critere) => `${critere.libelle} ${critere.scorePourcent}% x${critere.poids}`)
    .join(', ');
  const inconnus = (score.inconnus || []).length > 0
    ? ` Donnees ignorees car inconnues: ${score.inconnus.join(', ')}.`
    : '';
  return `${contributions || 'aucun critere disponible'}.${inconnus}`;
}

function couleurFranchissabilite(valeur) {
  const couleurs = {
    prete: '#16a34a',
    praticable: '#2563eb',
    clarification_necessaire: '#d97706',
    bloquee: '#dc2626',
    inconnue: '#9ca3af',
  };
  return couleurs[valeur] || '#9ca3af';
}

export default CockpitGrapheCognitif;



// WEBPACK FOOTER //
// src/components/cockpit/CockpitGrapheCognitif.js